import React, { useState } from 'react';
import { Check, Copy, KeyRound } from 'lucide-react';
import { Highlight, themes } from 'prism-react-renderer';
import { generateCode } from '../lib.js';

const LANGUAGES = [
  { id: 'curl', label: 'cURL', prism: 'bash' },
  { id: 'python', label: 'Python', prism: 'python' },
  { id: 'javascript', label: 'JavaScript', prism: 'javascript' },
];

export function CodeSample({ operation, draft, apiKey, compact = false }) {
  const [language, setLanguage] = useState('curl');
  const [copied, setCopied] = useState(false);
  const active = LANGUAGES.find((item) => item.id === language) || LANGUAGES[0];
  const code = generateCode(operation, language, draft, apiKey);

  const copy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return <section className={compact ? 'code-sample compact' : 'code-sample'}>
    <header>
      <div className="code-language-tabs">{LANGUAGES.map((item) => <button key={item.id} className={language === item.id ? 'active' : ''} onClick={() => setLanguage(item.id)}>{item.label}</button>)}</div>
      <button className="copy-snippet" onClick={copy}>{copied ? <Check size={14} /> : <Copy size={14} />}<span>{copied ? '已复制' : '复制'}</span></button>
    </header>
    {apiKey && <p className="code-key-note"><KeyRound size={13} /> 示例包含当前浏览器保存的 Key，请勿分享。</p>}
    <Highlight theme={themes.github} code={code} language={active.prism}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => <pre className={className} style={{ ...style, background: 'transparent' }}>
        {tokens.map((line, index) => <div key={index} {...getLineProps({ line })}>{line.map((token, tokenIndex) => <span key={tokenIndex} {...getTokenProps({ token })} />)}</div>)}
      </pre>}
    </Highlight>
  </section>;
}
